import AirlineIcon from './AirlineIcon';

export default AirlineIcon;
